/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_NameInputs */

const bn_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কান্ট্রি ড্যাশ`)
};

const de_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const el_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const en_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const es_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dash país`)
};

const fr_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pays Dash`)
};

const hi_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश डैश`)
};

const hu_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ország Dash`)
};

const id_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dash Negara`)
};

const it_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paese Dash`)
};

const ja_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カントリーダッシュ`)
};

const ko_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컨트리 대시`)
};

const nl_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Dash`)
};

const pl_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const pt_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traço do país`)
};

const ru_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страна Дэш`)
};

const sv_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const tr_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke Çizgisi`)
};

const uk_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country Dash`)
};

const vi_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dấu gạch ngang quốc gia`)
};

const zh_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`乡村短跑`)
};

const zh_hant_app_name = /** @type {(inputs: App_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`鄉村短跑`)
};

/**
* | output |
* | --- |
* | "Country Dash" |
*
* @param {App_NameInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const app_name = /** @type {((inputs?: App_NameInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_NameInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_app_name(inputs)
	if (locale === "de") return de_app_name(inputs)
	if (locale === "el") return el_app_name(inputs)
	if (locale === "en") return en_app_name(inputs)
	if (locale === "es") return es_app_name(inputs)
	if (locale === "fr") return fr_app_name(inputs)
	if (locale === "hi") return hi_app_name(inputs)
	if (locale === "hu") return hu_app_name(inputs)
	if (locale === "id") return id_app_name(inputs)
	if (locale === "it") return it_app_name(inputs)
	if (locale === "ja") return ja_app_name(inputs)
	if (locale === "ko") return ko_app_name(inputs)
	if (locale === "nl") return nl_app_name(inputs)
	if (locale === "pl") return pl_app_name(inputs)
	if (locale === "pt") return pt_app_name(inputs)
	if (locale === "ru") return ru_app_name(inputs)
	if (locale === "sv") return sv_app_name(inputs)
	if (locale === "tr") return tr_app_name(inputs)
	if (locale === "uk") return uk_app_name(inputs)
	if (locale === "vi") return vi_app_name(inputs)
	if (locale === "zh") return zh_app_name(inputs)
	return zh_hant_app_name(inputs)
});